<template>
    <div class="container">
        <div class="bg--white border-radius m-t-25 m-b-25 p-30">
            <h1>
                Dashboard
            </h1>
            <div class="row">
                <div class="col-6">
                    <canvas class="order-chart" data-order-chart>

                    </canvas>
                </div>
                <div class="col-6">
                    <canvas class="products-chart" data-product-chart>

                    </canvas>
                </div>
            </div>
            <div v-if="canReadProducts" class="row">
                <div class="col-12">
                    <div class="container-fluid d-flex flex-column flex-fill h-100">
                        <!-- TABLE -->
                        <ak-data-table
                                bundle="product"
                                definition="dashboard-grid"
                                :infiniteScroll="true"
                        />
                     </div>
                </div>
            </div>
        </div>

        <div class="bg--white border-radius m-t-25 m-b-25 p-30">
            <div class="row justify-content-center">
                <div class="col-2">
                    <img :src="image">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Chart from '../../../../vendor/chart.js/dist/Chart.bundle.min';

export default {
    name: 'Dashboard',
    data() {
        return {
            menu: [],
            currentUrl: window.location.href,
            image: null,
            canReadProducts: false,
        }
    },
    methods: {
        async createBarChart() {
            const canvas = document.querySelector('[data-order-chart]')
            let url = `${baseHref}/dashboard/ajax/getLastMonthsOrdersData`;
            await this.$get(url)
                    .then((result) => {
                        this.chart = new Chart(canvas, {
                            type: 'bar',
                            data: {
                                labels: result.labels,
                                datasets: [{
                                    label: 'Orders per maand',
                                    backgroundColor: 'rgb(40, 150, 255)',
                                    borderWidth: 0,
                                    data: result.values
                                }]
                            },
                            options: {
                                responsive: true,
                                legend: {
                                    position: 'top',
                                },
                                title: {
                                    display: true,
                                    text: 'Aantal bestellingen van de voorbije 6 maanden'
                                }
                            }
                        });
                    })
        },
        async createPieChart() {
            const canvas = document.querySelector('[data-product-chart]')
            let url = `${baseHref}/dashboard/ajax/getTopOrderedProductsData`;
            await this.$get(url)
                    .then((result) => {
                        this.chart = new Chart(canvas, {
                            type: 'pie',
                            data: {
                                labels: result.labels,
                                datasets: [{
                                    label: 'Top 10 bestelde producten',
                                    data: result.values,
                                    backgroundColor: [
                                        'rgb(40, 200, 255)',
                                        'rgb(55, 180, 255)',
                                        'rgb(70, 160, 255)',
                                        'rgb(85, 140, 255)',
                                        'rgb(100, 120, 255)',
                                        'rgb(115, 100, 255)',
                                        'rgb(130, 80, 255)',
                                        'rgb(145, 60, 255)',
                                        'rgb(160, 40, 255)',
                                        'rgb(175, 20, 255)',
                                    ],
                                    hoverOffset: 4
                                }]
                            },
                            options: {
                                responsive: true,
                                legend: {
                                    position: 'left',
                                },
                                title: {
                                    display: true,
                                    text: 'Top 10 bestelde producten'
                                }
                            }
                        });
                    })
        }
    },
    created() {
        const userInterface = this.$userInterfaceHandler.getUserInterface();

        if (userInterface) {
            this.menu = userInterface.menu;
            this.canReadProducts = userInterface.canReadProducts;
        }
    },
    mounted() {
        this.createBarChart();
        this.createPieChart();

        this.image = `${disclaimerImage}`;
    }
}
</script>
